module.exports = __webpack_public_path__ + "static/media/TipoDoc3.04b1701f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc3.png
// module id = 2193
// module chunks = 0